module.exports = __webpack_public_path__ + "img/60000.3b12f10a.jpg";